import type { Dispatch, SetStateAction } from "react";
import type { AdsAssistantOrgPrefs } from "@/lib/adsAssistantOrgSettings";

export function AdsAssistantOrgSettingsGhlSyncCard(props: {
  prefs: AdsAssistantOrgPrefs;
  setPrefs: Dispatch<SetStateAction<AdsAssistantOrgPrefs>>;
  loading: boolean;
}) {
  const { prefs, setPrefs, loading } = props;

  return (
    <div className="rounded-xl border border-indigo-200/80 bg-indigo-50/30 px-4 py-3 dark:border-indigo-900/50 dark:bg-indigo-950/20 space-y-3">
      <div>
        <h4 className="text-xs font-semibold text-gray-900 dark:text-gray-100">Nightly CRM ad sync</h4>
        <p className="mt-0.5 text-[11px] text-gray-600 dark:text-gray-400 max-w-prose">
          When enabled, a scheduled job pulls recent published Facebook and Google posts from CRM Social Planner for this
          org (org-wide, all active CRM connections). Manual sync in Ingestion still works anytime.
        </p>
      </div>

      <label className="inline-flex items-center gap-2 text-sm text-gray-900 dark:text-gray-100">
        <input
          type="checkbox"
          checked={prefs.ghl_auto_sync_enabled}
          onChange={(e) => setPrefs((pr) => ({ ...pr, ghl_auto_sync_enabled: e.target.checked }))}
          disabled={loading}
        />
        Enable nightly CRM sync (07:00 UTC)
      </label>

      <div className="grid gap-3 sm:grid-cols-2">
        <label className="text-xs text-gray-700 dark:text-gray-300 block">
          Days back
          <input
            type="number"
            min={1}
            max={90}
            className="mt-1 w-full text-sm border border-gray-200 dark:border-gray-600 rounded-lg px-3 py-2 bg-white dark:bg-zinc-900"
            value={prefs.ghl_auto_sync_days_back}
            onChange={(e) =>
              setPrefs((pr) => ({
                ...pr,
                ghl_auto_sync_days_back: Math.min(90, Math.max(1, parseInt(e.target.value, 10) || 7)),
              }))
            }
            disabled={loading || !prefs.ghl_auto_sync_enabled}
          />
        </label>
        <label className="text-xs text-gray-700 dark:text-gray-300 block">
          Max posts per run
          <input
            type="number"
            min={1}
            max={100}
            className="mt-1 w-full text-sm border border-gray-200 dark:border-gray-600 rounded-lg px-3 py-2 bg-white dark:bg-zinc-900"
            value={prefs.ghl_auto_sync_limit}
            onChange={(e) =>
              setPrefs((pr) => ({
                ...pr,
                ghl_auto_sync_limit: Math.min(100, Math.max(1, parseInt(e.target.value, 10) || 50)),
              }))
            }
            disabled={loading || !prefs.ghl_auto_sync_enabled}
          />
        </label>
      </div>
    </div>
  );
}
